import { Injectable } from "@angular/core";
import { DadosPaginacao } from "../paginacao/dadosPaginacao";
import { Observable } from "rxjs";
import { URL } from '../../_mocks/url';
import { ResultadoFiltragemContrato } from "./listagem-contrato/dto/resultadoFiltragemContrato";
import { FiltroListagemContrato } from "./listagem-contrato/dto/filtroListagemContrato";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class ContratoService {

    private urlContrato = URL + 'arquivo/contrato';

    constructor(
        private http: HttpClient
    ) { }

    getContratosByFilter(filtro: FiltroListagemContrato, dadosPaginacao?: DadosPaginacao): Observable<ResultadoFiltragemContrato> {
        const urlFinal = this.urlContrato + '/filter';
        const paginationQueryParams = this.dadosPaginacaoToQueryParam(dadosPaginacao);

        return this.http.post<ResultadoFiltragemContrato>(urlFinal, filtro, {
            params: paginationQueryParams
        });
    }

    dadosPaginacaoToQueryParam(dadosPaginacao: DadosPaginacao): { [key: string]: string } {
        if (!dadosPaginacao) {
            return {};
        }

        const paginacaoQueryParam = {};

        if (dadosPaginacao) {
            paginacaoQueryParam['page'] = dadosPaginacao.page;
            paginacaoQueryParam['size'] = dadosPaginacao.size;
        }

        return paginacaoQueryParam;
    }

    getExportarURI(tipoExportacao: string, filtro: FiltroListagemContrato, ultimoDadoPaginacao: DadosPaginacao) {

        const filterQueryParam = this.jsonToQueryString(filtro);
        console.log('filterQueryParam', filterQueryParam);

        const paginacaoQueryParam = this.jsonToQueryString(ultimoDadoPaginacao);
        console.log('paginacaoQueryParam', paginacaoQueryParam);

        const queryParams = `${filterQueryParam}&${paginacaoQueryParam}`;
        const recurso = `${this.urlContrato}/exportar/${tipoExportacao}?${queryParams}`;
        return recurso;
    }

    // TODO repetido aqui e no servico de licitacao... refatorar
    jsonToQueryString(json) {
        const queryString = Object
            .keys(json)
            .map((key) => {

                if (json[key] == undefined || json[key] == null) {
                    return '';
                }

                return encodeURIComponent(key) + '=' +
                    encodeURIComponent(json[key]);
            }).join('&');

        return queryString;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/contrato/contratoService.ts